import { render } from "./BenefitsAndInvestment.vue?vue&type=template&id=35e6a8a6&scoped=true"
import script from "./BenefitsAndInvestment.vue?vue&type=script&lang=js"
export * from "./BenefitsAndInvestment.vue?vue&type=script&lang=js"

import "./BenefitsAndInvestment.vue?vue&type=style&index=0&id=35e6a8a6&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e6a8a6"]])

export default __exports__